<div class="d-flex flex-row justify-content-between p-3 image-cropper-container">
  <div class="cropper-wrapper">
    <div *ngIf="!showCropper" class="img-text-centered upload-img">
      <div (click)="openAddImage()" class="d-flex flex-row">
        <div class="d-flex flex-column">
          <img src="assets/icons/add-image-plus-icon.svg">
        </div>
      </div>
    </div>
    <input style="display: none;" type="text" #eventImagePath/>
    <input (change)="onSelectFile($event)" class="open-file" style="display: none;" type="file" id="openFile" #openFile
           name="openFile" accept="image/png, image/jpg, image/jpeg"/>
    <image-cropper class="cropper-container"
                   [imageChangedEvent]="imageChangedEvent"
                   [maintainAspectRatio]="true"
                   [aspectRatio]="200 / 130"
                   [transform]="transform"
                   [canvasRotation]="canvasRotation"
                   (imageCropped)="imageCropped($event)"
                   (imageLoaded)="imageLoaded()"
                   (cropperReady)="cropperReady()"
                   (loadImageFailed)="loadImageFailed()"
                   [style.display]="showCropper ? null : 'none'">
    </image-cropper>

  </div>
  <div class="d-flex flex-column justify-content-between preview-wrapper">
    <div class="container-img">
      <div class="inner-preview-container">
        <img class="img" [src]="imagePath" alt="img-preview" *ngIf="imageName">
        <div *ngIf="!imageName" class="d-flex flex-row preview-img-placeholder">
          <img src="assets/icons/add-image-placeholder-icon.svg">
        </div>
      </div>
      <p class="preview-label mt-3">{{'INFO.PREVIEW' | translate}}</p>
    </div>
    <div>
      <div class="d-flex flex-wrap mt-4 justify-content-center align-items-center">
        <button class="btn_rotate_image w-100 mb-3" type="button" (click)="rotateRight()">
          <img src="assets/icons/rotate-image-icon.svg">{{'INFO.ROTATE' | translate}}
        </button>
        <button class="btn_in_color w-100 mb-3" type="button" (click)="save()">{{'SAVE' | translate}}</button>
        <button class="btn_without_color w-100" type="button" (click)="cancel()">{{'CANCEL' | translate}}</button>
      </div>
    </div>
  </div>
</div>

